import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

//实现懒加载
const sindex=resolve=>require(['../module/sindex.vue'],resolve);
//关于我们
const aboutUs=resolve=>require(['../module/aboutUs/aboutUs.vue'],resolve);
const parkIntroduction=resolve=>require(['../module/aboutUs/parkIntroduction.vue'],resolve);
const leaderCare=resolve=>require(['../module/aboutUs/leaderCare.vue'],resolve);
const parkView=resolve=>require(['../module/aboutUs/parkView.vue'],resolve);
const joinUS=resolve=>require(['../module/aboutUs/joinUs.vue'],resolve);
const contactUs=resolve=>require(['../module/aboutUs/contactUs.vue'],resolve);
const leaderCareDetail=resolve=>require(['../module/aboutUs/leaderCareDetail.vue'],resolve);
//最新资讯
const news =resolve =>require(['../module/news/news.vue'],resolve);
const wordNews =resolve =>require(['../module/news/wordNews.vue'],resolve);
const videoNews =resolve =>require(['../module/news/videoNews.vue'],resolve);
const newsDetail =resolve =>require(['../module/news/newsDetail.vue'],resolve);
//产业活动
const industrial=resolve =>require(['../module/industrial/industrial.vue'],resolve);
const industryDetail=resolve =>require(['../module/industrial/industryDetail.vue'],resolve);
//服务配套
const servicePackFather=resolve=>require(['../module/servicePack/servicePackFather.vue'],resolve);  //服务配套父级
const servicePack=resolve=>require(['../module/servicePack/servicePack.vue'],resolve);  //服务配套
const packDetail=resolve=>require(['../module/servicePack/packDetail.vue'],resolve);    //配套详情
// const serviceMenu=resolve=>require(['../module/servicePack/serviceMenu.vue'],resolve);    //配套详情
//政策政务
const policyAdministration=resolve=>require(['../module/policyAdministration/policyAdministration.vue'],resolve);
//海南生态智慧新城
const wisdomCity = resolve => require(['../module/wisdomCity/wisdomCity.vue'], resolve);
const wisdomCityDetail = resolve => require(['../module/wisdomCity/wisdomCityDetail.vue'], resolve);

Vue.config.productionTip = false

//获取浏览器默认语言
/*var defaultLang="";
if(navigator.language=="zh-CN"){
    defaultLang="zh";
}else if(navigator.language=="ru"){
    defaultLang="ru";
}else{
    defaultLang="en";
}*/

//路由配置
const router = new VueRouter({
    mode: 'history',
    //base: process.env.NODE_ENV === 'production'? '/rsc-project': '',
    linkActiveClass:'active',
    /*scrollBehavior(to,from,savedPosition){
        return {x:0,y:0}
    },*/
    routes: [
        /*中文*/
        {path:'/zh/sindex',meta:{title:'首页'},component:sindex},
        //关于我们
        {path:'/zh/aboutUs',meta:{title:'关于我们'},component:aboutUs,
            children:[
                {path:'parkIntroduction',meta:{title:'园区简介'},component:parkIntroduction},
                {path:'leaderCare',meta:{title:'领导关怀'},component:leaderCare},
                {path:'parkView',meta:{title:'园区实景'},component:parkView},
                {path:'joinUS',meta:{title:'加入我们'},component:joinUS},
                {path:'contactUs',meta:{title:'联系我们'},component:contactUs},
                {path:'leaderCareDetail',meta:{title:'详情'},component:leaderCareDetail},
                {path:'/',redirect:'parkIntroduction'},
            ]
        },
        //最新资讯
        {path:'/zh/news',meta:{title:'最新资讯'},component:news,children:[
            {path:'wordNews',meta:{title:'图文资讯'},component:wordNews},
            {path:'videoNews',meta:{title:'视频资讯'},component:videoNews},
            {path:'/',redirect:'wordNews'},
        ]},
        {path:'/zh/newsDetail',meta:{title:'资讯详情'},component:newsDetail},
        //产业活动
        {path:'/zh/industrial',meta:{title:'产业活动'},component:industrial},
        {path:'/zh/industryDetail',meta:{title:'活动详情'},component:industryDetail},
        //服务配套
        {path:'/zh/servicePackFather',meta:{title:'服务配套'},component:servicePackFather,
            children:[
                {path:'servicePack',meta:{title:'服务配套'},component:servicePack},
                {path:'packDetail',meta:{title:'配套详情'},component:packDetail},
                {path:'/',redirect:'servicePack'},
            ]
        },
        // {path:'/zh/serviceMenu',meta:{title:'服务配套'},component:serviceMenu},
        //政策政务
        {path:'/zh/policyAdministration',meta:{title:'政策政务'},component:policyAdministration},
        //海南生态智慧新城
        {path:'/zh/wisdomCity',meta:{title:'海南生态智慧新城'},component:wisdomCity,
            children: [
                { path: 'wisdomCityDetail', meta: { title: '海南生态智慧新城' }, component: wisdomCityDetail },
                { path: '/', redirect: 'wisdomCityDetail'},
            ]
        },
        /*英文*/
        {path:'/en/sindex',meta:{title:'首页'},component:sindex},
        //关于我们
        {path:'/en/aboutUs',meta:{title:'关于我们'},component:aboutUs,
            children:[
                {path:'parkIntroduction',meta:{title:'园区简介'},component:parkIntroduction},
                {path:'leaderCare',meta:{title:'领导关怀'},component:leaderCare},
                {path:'parkView',meta:{title:'园区实景'},component:parkView},
                {path:'joinUS',meta:{title:'加入我们'},component:joinUS},
                {path:'contactUs',meta:{title:'联系我们'},component:contactUs},
                {path:'leaderCareDetail',meta:{title:'详情'},component:leaderCareDetail},
                {path:'/',redirect:'parkIntroduction'},
            ]
        },
        //最新资讯
        {path:'/en/news',meta:{title:'最新资讯'},component:news,children:[
            {path:'wordNews',meta:{title:'图文资讯'},component:wordNews},
            {path:'videoNews',meta:{title:'视频资讯'},component:videoNews},
            {path:'/',redirect:'wordNews'},
        ]},
        {path:'/en/newsDetail',meta:{title:'资讯详情'},component:newsDetail},
        //产业活动
        {path:'/en/industrial',meta:{title:'产业活动'},component:industrial},
        {path:'/en/industryDetail',meta:{title:'活动详情'},component:industryDetail},
        //服务配套
        {path:'/en/servicePackFather',meta:{title:'服务配套'},component:servicePackFather,
            children:[
                {path:'servicePack',meta:{title:'服务配套'},component:servicePack},
                {path:'packDetail',meta:{title:'配套详情'},component:packDetail},
                {path:'/',redirect:'servicePack'},
            ]
        },
        // {path:'/ru/serviceMenu',meta:{title:'服务配套'},component:serviceMenu},
        //政策政务
        {path:'/en/policyAdministration',meta:{title:'政策政务'},component:policyAdministration},
        //海南生态智慧新城
        {path:'/en/wisdomCity',meta:{title:'海南生态智慧新城'},component:wisdomCity,
            children: [
                { path: 'wisdomCityDetail', meta: { title: '海南生态智慧新城' }, component: wisdomCityDetail },
                { path: '/', redirect: 'wisdomCityDetail'},
            ]
        },
        /*俄文*/
        {path:'/ru/sindex',meta:{title:'首页'},component:sindex},
        //关于我们
        {path:'/ru/aboutUs',meta:{title:'关于我们'},component:aboutUs,
            children:[
                {path:'parkIntroduction',meta:{title:'园区简介'},component:parkIntroduction},
                {path:'leaderCare',meta:{title:'领导关怀'},component:leaderCare},
                {path:'parkView',meta:{title:'园区实景'},component:parkView},
                {path:'joinUS',meta:{title:'加入我们'},component:joinUS},
                {path:'contactUs',meta:{title:'联系我们'},component:contactUs},
                {path:'leaderCareDetail',meta:{title:'详情'},component:leaderCareDetail},
                {path:'/',redirect:'parkIntroduction'},
            ]
        },
        //最新资讯
        {path:'/ru/news',meta:{title:'最新资讯'},component:news,children:[
            {path:'wordNews',meta:{title:'图文资讯'},component:wordNews},
            {path:'videoNews',meta:{title:'视频资讯'},component:videoNews},
            {path:'/',redirect:'wordNews'},
        ]},
        {path:'/ru/newsDetail',meta:{title:'资讯详情'},component:newsDetail},
        //产业活动
        {path:'/ru/industrial',meta:{title:'产业活动'},component:industrial},
        {path:'/ru/industryDetail',meta:{title:'活动详情'},component:industryDetail},
        //服务配套
        {path:'/ru/servicePack',meta:{title:'服务配套'},component:servicePackFather,
            children:[
                {path:'servicePackFather',meta:{title:'服务配套'},component:servicePack},
                {path:'packDetail',meta:{title:'配套详情'},component:packDetail},
                {path:'/',redirect:'servicePack'},
            ]
        },
        // {path:'/ru/serviceMenu',meta:{title:'服务配套'},component:serviceMenu},
        //政策政务
        {path:'/ru/policyAdministration',meta:{title:'政策政务'},component:policyAdministration},
        //海南生态智慧新城
        {path:'/ru/wisdomCity',meta:{title:'海南生态智慧新城'},component:wisdomCity,
            children: [
                { path: 'wisdomCityDetail', meta: { title: '海南生态智慧新城' }, component: wisdomCityDetail },
                { path: '/', redirect: 'wisdomCityDetail'},
            ]
        },



        {path:'/',redirect:'/zh/sindex'},
    ],
});

router.beforeEach((to, from, next) => {
    next();
    //document.title=to.meta.title;
});

export default router;
